module.exports = __webpack_public_path__ + "static/media/ic_notfound.42d3fcad.svg";